var utils = require('../../utils')

export default {
  name: 'medicine-list',
  data: function () {
    return {
      medicineName: '',
      medicineTypeCode: null,
      dialogError: '',
      isSelectMode: false,
      searchCallbackFlag: false,
      watchScroll: null,
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'medicine_name' : {'state': true,  'order': true},
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.medicinesSearchParams !== null) {
        this.$store.getters.medicinesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.medicinesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created: function () {
    var readMore = false
    var ssMedicineName = window.sessionStorage.getItem('ml-medicineName')
    var ssSortKey = window.sessionStorage.getItem('ml-sortKey')
    var ssSortStateOrder = window.sessionStorage.getItem('ml-sortStateOrder')
    var ssMedicineTypeCode = window.sessionStorage.getItem('ml-medicineTypeCode')
    if (!!ssMedicineName) {
      this.medicineName = ssMedicineName
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }
    if (!!ssMedicineTypeCode) {
      this.medicineTypeCode = ssMedicineTypeCode
    }
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    if (this.$router.currentRoute.query.type == 'select') {
      this.isSelectMode = true
    }

    this.$store.dispatch('MEDICINE_TYPE_SEARCH')
    this.search(readMore)
    
    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    importMessage() {
      return this.$t(this.$store.getters.medicineImportMessage)
    },
    importLogs() {
      var logs = this.$store.getters.medicineImportLogs
      if( this.dialogError ){
        logs += '\n' + this.dialogError
      }
      return logs
    },
    medicines() {
      return this.$store.getters.medicines
    },
    nextPage() {
      return this.$store.getters.medicinesNextPage
    },
    /** システム管理者 */
    isAdmin() {
      return this.$store.getters.userAdmin
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.medicinesCurrentPage
    },
    totalCount() {
      return this.$store.getters.medicinesTotalCount
    },
    medicineTypes() {
      if (utils.isBlank(this.$store.getters.medicineTypeList) || Object.keys(this.$store.getters.medicineTypeList).length <= 0) {
        return null
      }
      var result = []
      var arr = this.$store.getters.medicineTypeList['data']
      for (var i = 0; i < arr.length; i++) {
        result.push(arr[i])
      }
      result.unshift({'medicine_type_code': null, 'medicine_type_name': this._self.$t('medicines.medicine_type_name_none')})
      return result
    }
  },
  methods: {
    onDragOver : function(event){
      event.preventDefault();
    },
    onDrop : function(event){
      console.log("onDrop")
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault();

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files;
      this.import(files)
    },
    onFileChange : function(event){
      console.log("onFileChange")

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files;
      this.import(files)
    },
    import: function(files){
      this.$store.dispatch('MEDICINE_CSV_IMPORT_START')
      if (files.length != 1) {
          this.dialogError = this.$t('medicines.err_file_length')
          return
      }

      // エラーログクリア
      this.dialogError = ''

      var formData = new FormData();
      formData.append('medicine_csv', files[0]);

      this.$store.dispatch('MEDICINE_CSV_IMPORT', {data: formData})

      // CSV取り込みによる変更を検索結果リストに反映
      this.search(false)
    },
    onDropMaster : function(event){
      console.log("onDropMaster")
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault();

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files;
      this.importMaster(files)
    },
    onFileChangeMaster : function(event){
      console.log("onFileChangeMaster")

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files;
      this.importMaster(files)
    },
    importMaster: function(files){
      this.$store.dispatch('MEDICINE_CSV_MASTER_IMPORT_START')
      if (files.length != 1) {
          this.dialogError = this.$t('medicines.err_file_length')
          return
      }

      // エラーログクリア
      this.dialogError = ''

      var formData = new FormData();
      formData.append('medicine_csv', files[0]);

      this.$store.dispatch('MEDICINE_CSV_MASTER_IMPORT', {data: formData})

      // CSV取り込みによる変更を検索結果リストに反映
      this.search(false)
    },
    search: function (readMore) {
      var url = null
      var clear = true
      var loadparams = true

      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.medicinesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.medicinesSearchParams['scrollHeight']
        this.$store.getters.medicinesSearchParams['pageYOffset'] = null
        this.$store.getters.medicinesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.medicinesNextPage
        clear = false
        loadparams = 'block'
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'medicine_name':    this.medicineName,
        'medicine_type_code': this.medicineTypeCode,
        'order':            this.orderByString()
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      if (!!this.medicineName) {
        window.sessionStorage.setItem('ml-medicineName', this.medicineName)
      } else {
        window.sessionStorage.removeItem('ml-medicineName')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("ml-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("ml-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("ml-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("ml-sortStateOrder")
      }
      if (!!this.medicineTypeCode) {
        window.sessionStorage.setItem('ml-medicineTypeCode', this.medicineTypeCode)
      } else {
        window.sessionStorage.removeItem('ml-medicineTypeCode')
      }

      this.$store.dispatch('MEDICINE_SEARCH', {url: url ,clear: clear ,data: data, loadparams: loadparams, callback: callback})
    },
    clearSearchParams: function() {
      this.medicineName = null
      this.$store.dispatch('MEDICINE_CLEAR', 0)
    },
    goMedicinesDetail: function(medicineId) {

      var query = {}
      if (this.isSelectMode) {
        query['type'] = 'select'
      }

      this.$router.push({ path: '/medicines/' + medicineId, query: query})
    },
    splitText: function(text) {
      return text.split('\n')
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('medicine_name asc')
      }
      return result.join(' , ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/medicine-list.js